module.exports = __webpack_public_path__ + "img/back.5598cf40.png";